import keyboardOnlyOutlines from '@moxy/keyboard-only-outlines'

keyboardOnlyOutlines({
  styles: `
  body *:focus, body *:active {
    outline: 1px dashed transparent !important;
  }
  body *::-moz-focus-inner {
    border: none !important;
  }`,
  stylesheetTarget: document.head
})
